<mat-button-toggle-group class="group" name="fontStyle" aria-label="Font Style" multiple="false" #group="matButtonToggleGroup"
    (change)="switch()" [ngClass]="{'mat-form-field-invalid': ngControl.invalid}" [disabled]="isDisabled" value="null">
    <mat-button-toggle [value]="true">
        <fa-icon [icon]="faCheck" size="2x"></fa-icon><br />Yes
    </mat-button-toggle>
    <mat-button-toggle [value]="false">
        <fa-icon [icon]="faTimes" size="2x"></fa-icon><br />No
    </mat-button-toggle>
</mat-button-toggle-group>
